import PropTypes from 'prop-types';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { TextField } from '@mui/material';

// ----------------------------------------------------------------------

RHFTextField.propTypes = {
  name: PropTypes.string,
  helperText: PropTypes.node,
  placeholderCurrency: PropTypes.bool,
};

export default function RHFTextField({ name, helperText,placeholderCurrency = false, ...other }) {
  const { control } = useFormContext();

  const formatPlaceholder = () => {
    if (placeholderCurrency) return 'Rp 0';
    return '';
  };
  const handleChange = (e, field) => {
    const value = e.target.value;
    if (placeholderCurrency) {
      // Hanya izinkan angka jika currency
      const numeric = value.replace(/[^\d]/g, '');
      field.onChange(numeric);
    } else {
      field.onChange(value);
    }
  };

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          fullWidth
          value={typeof field.value === 'number' && field.value === 0 ? '' : field.value}
          onChange={(e) => handleChange(e, field)}
          error={!!error}
          helperText={error ? error?.message : helperText}
          placeholder={formatPlaceholder()}
          inputProps={{
            inputMode: placeholderCurrency ? 'numeric' : 'text',
            pattern: placeholderCurrency ? '[0-9]*' : undefined,
          }}
          {...other}
        />
      )}
    />
  );
}
